import React from "react";
import "./LegalPages.css";

const SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    content: `By accessing and using variantexclusive.com, you accept and agree to be bound by these Terms and Conditions. If you do not agree, please do not use our website or services.`,
  },
  {
    title: "2. Products & Orders",
    content: `All products sold on Variant Exclusive are custom 3D printed and made to order. Due to the handcrafted nature of our products, slight variations in color and finish may occur. We reserve the right to cancel any order at our discretion with a full refund.`,
  },
  {
    title: "3. Pricing & Payment",
    content: `All prices are listed in Indian Rupees (INR) and include applicable taxes. We accept UPI, Debit/Credit Cards, Net Banking, and Cash on Delivery (a ₹100 COD charge applies). Prices are subject to change without notice. Your order total at the time of checkout is the final price.`,
  },
  {
    title: "4. Shipping & Delivery",
    content: `We ship across India. Orders are dispatched within 3–7 business days after confirmation. Delivery timelines depend on your location and courier partner. We are not responsible for delays caused by courier services, natural disasters, or other events beyond our control.`,
  },
  {
    title: "5. Returns & Refunds",
    content: `Since our products are made to order, we do not accept returns unless the product is damaged, defective, or incorrect. Refund requests must be raised within 48 hours of delivery with photographic evidence. Approved refunds are processed within 5–7 business days to the original payment method.`,
  },
  {
    title: "6. Intellectual Property",
    content: `All content on this website — including images, logos, product designs, and text — is the property of Variant Exclusive. You may not reproduce, distribute, or use any content without our prior written consent.`,
  },
  {
    title: "7. User Responsibilities",
    content: `You agree not to use this website for any unlawful purpose, submit false information, or attempt to interfere with the website's operation. You are responsible for maintaining the confidentiality of any account credentials.`,
  },
  {
    title: "8. Limitation of Liability",
    content: `Variant Exclusive shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or website. Our maximum liability is limited to the amount paid for the specific order in question.`,
  },
  {
    title: "9. Privacy",
    content: `Your personal information is collected and used solely for processing orders and improving our services. We do not sell or share your data with third parties except as required for order fulfillment (courier partners, payment gateways). Please refer to our Privacy Policy for details.`,
  },
  {
    title: "10. Changes to Terms",
    content: `We reserve the right to update these Terms & Conditions at any time. Changes will be posted on this page with a revised date. Continued use of the website after changes constitutes your acceptance of the new terms.`,
  },
  {
    title: "11. Contact",
    content: `For any questions regarding these Terms & Conditions, please contact us at variantexclusive@gmail.com or call +91 98257 34352.`,
  },
];

export default function TermsAndConditions() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms & Conditions</h1>
        <p className="legal-updated">Last updated: August 2026</p>

        {SECTIONS.map(({title, content}) => (
          <section key={title}>
            <h2>{title}</h2>
            <p>{content}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
